import { Checkbox as MUICheckbox } from '@mui/material';
import { withStyles } from '@mui/styles';
import Theme from 'App.theme';

const Checkbox = withStyles({
  root: {
    color: Theme.colours.primary,
    '&.MuiIconButton-root:hover': {
      backgroundColor: Theme.colours.primary + 20,
    },
    '&$checked': {
      color: Theme.colours.primary,
    },
  },
  checked: {},
})(MUICheckbox);

export default Checkbox;
